import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'en' : import.meta.env.VITE_APP_LANG);

// bycursor-start
/**
 * 获取开发环境Token
 * @author bycursor
 * @returns {string} Bearer token
 */
export const getDevToken = () => {
  const customToken = sessionStorage.getItem('devToken');
  return customToken ? `Bearer ${customToken}` : `Bearer `;
};
// bycursor-end

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';

// Contains cursor-generated edits.
